<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>{{ asset.id ? 'Edit ' : 'Create ' }} Asset</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<form #f="ngForm" (ngSubmit)="onSubmit(f, false)">

  <hr class="m-0 p-0">

  <mat-dialog-content class="px-3 pt-4 pb-2">

    <div class="row">

      <div class="col-12 col-xl-6">

        <div class="row">
          <div class="col-12">
            <mat-form-field class="full-width mb-3" appearance="outline" subscriptSizing="dynamic">
              <mat-label>Name</mat-label>
              <input
                matInput
                placeholder="Name"
                [(ngModel)]="asset.name"
                name="name"
                type="text"
                required
                #name />
              <mat-hint>Please enter an asset name.</mat-hint>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-6">
            <mat-form-field class="full-width mb-3" appearance="outline" subscriptSizing="dynamic">
              <mat-label>Code Prefix</mat-label>
              <input
                matInput
                placeholder="Code Prefix"
                [(ngModel)]="asset.code_prefix"
                name="code_prefix"
                type="text"
                required
                minlength="3"
                maxlength="6"
                pattern="^[a-zA-Z0-9]*$"
                #codePrefixModel="ngModel"
                (blur)="asset.code_prefix = asset.code_prefix?.toUpperCase()" />
              <mat-hint>Please enter an asset code prefix between 3 and 6 alphanumeric characters.</mat-hint>
              <mat-error *ngIf="codePrefixModel.errors?.['required']">Code Prefix is required.</mat-error>
              <mat-error *ngIf="codePrefixModel.errors?.['minlength'] || codePrefixModel.errors?.['maxlength']">Code Prefix must be between 3 and 6 alphanumeric characters.</mat-error>
              <mat-error *ngIf="codePrefixModel.errors?.['pattern']">Only letters and numbers are allowed.</mat-error>
            </mat-form-field>
          </div>
          <div class="col-12 col-md-6">
            <mat-form-field class="full-width mb-3" appearance="outline" subscriptSizing="dynamic">
              <mat-label>Status:</mat-label>
              <mat-select [(ngModel)]="asset.status" required name="status" aria-label="Select the status of the asset.">
                <mat-option *ngFor="let status of statusOptions" [value]="status.value">{{ status.label }}</mat-option>
              </mat-select>
              <mat-hint>Select the status of the asset.</mat-hint>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-6">
            <mat-form-field class="full-width mb-3" appearance="outline" subscriptSizing="dynamic">
              <mat-label>Condition Rating:</mat-label>
              <mat-select [(ngModel)]="asset.condition_rating" required name="condition_rating" aria-label="Select the condition rating of the asset.">
                <mat-option *ngFor="let condition_rating of conditionRatingOptions" [value]="condition_rating.value">{{ condition_rating.label }}</mat-option>
              </mat-select>
              <mat-hint>Select the condition rating of the asset.</mat-hint>
            </mat-form-field>
          </div>
          <div class="col-12 col-md-6">
            <mat-form-field class="full-width mb-3" appearance="outline" subscriptSizing="dynamic">
              <mat-label>Owner Type:</mat-label>
              <mat-select [(ngModel)]="asset.owner_type" required name="owner_type" aria-label="Select the owner type of the asset.">
                <mat-option *ngFor="let owner_type of ownerTypeOptions" [value]="owner_type.value">{{ owner_type.label }}</mat-option>
              </mat-select>
              <mat-hint>Select the owner type of the asset.</mat-hint>
            </mat-form-field>
          </div>
        </div>

        <div class="row" *ngIf="assetsService.isNotOwned(asset.owner_type)">
          <div class="col-12">
            <mat-form-field class="full-width mb-3" appearance="outline" subscriptSizing="dynamic">
              <mat-label>Owner Notes</mat-label>
              <textarea
                matInput
                rows="5"
                placeholder="Owner Notes"
                [(ngModel)]="asset.owner_notes"
                name="owner_notes"
                id="owner_notes">
              </textarea>
              <mat-hint>Enter any owner notes for the asset.</mat-hint>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <mat-form-field class="full-width mb-3" appearance="outline" subscriptSizing="dynamic">
              <mat-label>Location</mat-label>
              <input
                matInput
                placeholder="Location"
                [(ngModel)]="asset.location"
                name="location"
                type="text"
                #location />
              <mat-hint>Please enter an asset location.</mat-hint>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-6">
            <mat-form-field class="full-width mb-3 cost-amount-field" appearance="outline" subscriptSizing="dynamic">
              <mat-label>Cost Amount</mat-label>
              <span matPrefix class="cost-amount-prefix">{{ assetsService.getCostAmountPrefix(app.account.currency_code) }}</span>
              <input
                matInput
                type="number"
                name="cost_amount"
                min="0"
                [step]="assetsService.getCurrencyStep(app.account.currency_code)"
                [placeholder]="assetsService.getCurrencyPlaceholder(app.account.currency_code)"
                [(ngModel)]="costAmountInput"
                (ngModelChange)="onCostAmountChange($event)"
                (blur)="onCostAmountBlur()"
              />
              <mat-hint>Please enter an asset cost amount.</mat-hint>
              <mat-error *ngIf="costAmountError">
                {{ costAmountError }}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-12 col-md-6">
            <mat-form-field class="full-width mb-3" appearance="outline" subscriptSizing="dynamic" *ngIf="!assetsService.isRecurringPayment(asset.owner_type)">
              <mat-label>Purchased Date</mat-label>
              <input
                matInput
                (dateInput)="onCostStartDateChange($event.value)"
                [matDatepicker]="picker"
                [max]="today"
                placeholder="Purchased Date"
                [(ngModel)]="asset.cost_start_at"
                name="purchased_at"
                readonly
                (click)="picker.open()"/>
              <mat-datepicker-toggle matSuffix [for]="picker"> </mat-datepicker-toggle>
              <button type="button" matSuffix mat-icon-button *ngIf="asset.cost_start_at" (click)="asset.cost_start_at = null" matTooltip="Remove the asset purchased date."><mat-icon>close</mat-icon></button>
              <mat-datepicker #picker></mat-datepicker>
              <mat-hint>Select the asset purchased date.</mat-hint>
            </mat-form-field>

            <mat-form-field class="full-width mb-3" appearance="outline" subscriptSizing="dynamic" *ngIf="assetsService.isRecurringPayment(asset.owner_type)">
              <mat-label>Billing Frequency:</mat-label>
              <mat-select [(ngModel)]="asset.cost_frequency" name="cost_frequency" aria-label="Select the billing frequency of the asset.">
                <mat-option [value]="null">None</mat-option>
                <mat-option *ngFor="let cost_frequency of costFrequencyOptions" [value]="cost_frequency.value">{{ cost_frequency.label }}</mat-option>
              </mat-select>
              <mat-hint>Select the billing frequency of the asset.</mat-hint>
            </mat-form-field>
          </div>
        </div>

        <div class="row" *ngIf="assetsService.isRecurringPayment(asset.owner_type)">
          <div class="col-12 col-md-6">
            <mat-form-field class="full-width mb-3" appearance="outline" subscriptSizing="dynamic">
              <mat-label>Billing Start Date</mat-label>
              <input
                matInput
                (dateInput)="onCostStartDateChange($event.value)"
                [matDatepicker]="picker_start"
                placeholder="Billing Start Date"
                [(ngModel)]="asset.cost_start_at"
                name="cost_start_at"
                readonly
                (click)="picker_start.open()"/>
              <mat-datepicker-toggle matSuffix [for]="picker_start"> </mat-datepicker-toggle>
              <button type="button" matSuffix mat-icon-button *ngIf="asset.cost_start_at" (click)="asset.cost_start_at = null" matTooltip="Remove the asset billing start date."><mat-icon>close</mat-icon></button>
              <mat-datepicker #picker_start></mat-datepicker>
              <mat-hint>Select the asset billing start date.</mat-hint>
            </mat-form-field>
          </div>
          <div class="col-12 col-md-6">
            <mat-form-field class="full-width mb-3" appearance="outline" subscriptSizing="dynamic">
              <mat-label>Billing End Date</mat-label>
              <input
                matInput
                (dateInput)="onCostEndDateChange($event.value)"
                [matDatepicker]="picker_end"
                placeholder="Billing End Date"
                [(ngModel)]="asset.cost_end_at"
                name="cost_end_at"
                readonly
                (click)="picker_end.open()"/>
              <mat-datepicker-toggle matSuffix [for]="picker_end"> </mat-datepicker-toggle>
              <button type="button" matSuffix mat-icon-button *ngIf="asset.cost_end_at" (click)="asset.cost_end_at = null" matTooltip="Remove the asset billing end date."><mat-icon>close</mat-icon></button>
              <mat-datepicker #picker_end></mat-datepicker>
              <mat-hint>Select the asset billing end date.</mat-hint>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <mat-form-field class="full-width mb-3" appearance="outline" subscriptSizing="dynamic">
              <mat-label>Description</mat-label>
              <textarea
                matInput
                rows="5"
                placeholder="Description"
                [(ngModel)]="asset.description"
                name="description"
                id="description">
              </textarea>
              <mat-hint>Enter a description for the asset.</mat-hint>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-6">
            <mat-form-field class="full-width mb-3" appearance="outline" subscriptSizing="dynamic">
              <mat-label>Serial Number</mat-label>
              <input
                matInput
                placeholder="Serial Number"
                [(ngModel)]="asset.serial_no"
                name="serial_no"
                type="text"
                #serial_no />
              <mat-hint>Please enter an asset serial number.</mat-hint>
            </mat-form-field>
          </div>
          <div class="col-12 col-md-6">
            <mat-form-field class="full-width mb-3" appearance="outline" subscriptSizing="dynamic">
              <mat-label>Part Number</mat-label>
              <input
                matInput
                placeholder="Part Number"
                [(ngModel)]="asset.part_no"
                name="part_no"
                type="text"
                #part_no />
              <mat-hint>Please enter an asset part number.</mat-hint>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-6">
            <mat-form-field class="full-width mb-3" appearance="outline" subscriptSizing="dynamic">
              <mat-label>Purchase Order Number</mat-label>
              <input
                matInput
                placeholder="Purchase Order Number"
                [(ngModel)]="asset.purchase_order_no"
                name="purchase_order_no"
                type="text"
                #purchase_order_no />
              <mat-hint>Please enter an asset purchase order number.</mat-hint>
            </mat-form-field>
          </div>
          <div class="col-12 col-md-6">
            <mat-form-field class="full-width mb-3" appearance="outline" subscriptSizing="dynamic">
              <mat-label>Vehicle Registration Number</mat-label>
              <input
                matInput
                placeholder="Vehicle Registration Number"
                [(ngModel)]="asset.vehicle_reg_no"
                name="vehicle_reg_no"
                type="text"
                #vehicle_reg_no />
              <mat-hint>Please enter an asset vehicle registration number.</mat-hint>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-6">
            <mat-form-field class="full-width mb-3" appearance="outline" subscriptSizing="dynamic">
              <mat-label>Noise Rating (dB)</mat-label>
              <input
                matInput
                type="number"
                name="noise_rating_db"
                min="0"
                max="140"
                step="1"
                placeholder="0"
                [(ngModel)]="asset.noise_rating_db"
                (ngModelChange)="onNoiseRatingChange($event)"
                (blur)="onNoiseRatingBlur()"
              />
              <mat-hint>
                Please enter an asset noise rating between 0 and 140 dB.
              </mat-hint>
              <mat-error *ngIf="noiseRatingError">
                {{ noiseRatingError }}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-12 col-md-6">
            <mat-form-field class="full-width mb-3" appearance="outline" subscriptSizing="dynamic">
              <mat-label>Emissions Class</mat-label>
              <input
                matInput
                placeholder="Emissions Class"
                [(ngModel)]="asset.emissions_class"
                name="emissions_class"
                type="text"
                #emissions_class />
              <mat-hint>Please enter an asset emissions class.</mat-hint>
            </mat-form-field>
          </div>
        </div>

      </div>

      <div class="col-12 col-xl-6">

        <div class="row">
          <div class="col">
            <mat-form-field class="full-width mb-3" appearance="outline" subscriptSizing="dynamic">
              <mat-label>Expected Replacement Date</mat-label>
              <input
                matInput
                (dateInput)="onExpectedReplacementDateChange($event.value)"
                [matDatepicker]="picker_1"
                placeholder="Expected Replacement Date"
                [(ngModel)]="asset.expected_replacement_at"
                name="expected_replacement_at"
                readonly
                (click)="picker_1.open()"/>
              <mat-datepicker-toggle matSuffix [for]="picker_1"> </mat-datepicker-toggle>
              <button type="button" matSuffix mat-icon-button *ngIf="asset.expected_replacement_at" (click)="asset.expected_replacement_at = null" matTooltip="Remove the asset expected replacement date."><mat-icon>close</mat-icon></button>
              <mat-datepicker #picker_1></mat-datepicker>
              <mat-hint>Select the asset expected replacement date.</mat-hint>
            </mat-form-field>
          </div>
          <div class="col">
            <mat-form-field class="full-width mb-3" appearance="outline" subscriptSizing="dynamic">
              <mat-label>Warranty Expiry Date</mat-label>
              <input
                matInput
                (dateInput)="onWarrantyExpiryDateChange($event.value)"
                [matDatepicker]="picker_2"
                placeholder="Warranty Expiry Date"
                [(ngModel)]="asset.warranty_expiry_date"
                name="warranty_expiry_date"
                readonly
                (click)="picker_2.open()"/>
              <mat-datepicker-toggle matSuffix [for]="picker_2"> </mat-datepicker-toggle>
              <button type="button" matSuffix mat-icon-button *ngIf="asset.warranty_expiry_date" (click)="asset.warranty_expiry_date = null" matTooltip="Remove the asset warranty expiry date."><mat-icon>close</mat-icon></button>
              <mat-datepicker #picker_2></mat-datepicker>
              <mat-hint>Select the asset warranty expiry date.</mat-hint>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <mat-form-field class="full-width mb-3" appearance="outline" subscriptSizing="dynamic">
              <mat-label>Maintenance Due Date</mat-label>
              <input
                matInput
                (dateInput)="onMaintenanceDueDateChange($event.value)"
                [matDatepicker]="picker_3"
                placeholder="Maintenance Due Date"
                [(ngModel)]="asset.maintenance_due_date"
                name="maintenance_due_date"
                readonly
                (click)="picker_3.open()"/>
              <mat-datepicker-toggle matSuffix [for]="picker_3"> </mat-datepicker-toggle>
              <button type="button" matSuffix mat-icon-button *ngIf="asset.maintenance_due_date" (click)="asset.maintenance_due_date = null" matTooltip="Remove the asset maintenance due date."><mat-icon>close</mat-icon></button>
              <mat-datepicker #picker_3></mat-datepicker>
              <mat-hint>Select the asset maintenance due date.</mat-hint>
            </mat-form-field>
          </div>
          <div class="col">
            <mat-form-field class="full-width mb-3" appearance="outline" subscriptSizing="dynamic">
              <mat-label>Inspection Due Date</mat-label>
              <input
                matInput
                (dateInput)="onInspectionDueDateChange($event.value)"
                [matDatepicker]="picker_4"
                placeholder="Inspection Due Date"
                [(ngModel)]="asset.next_inspection_due_date"
                name="next_inspection_due_date"
                readonly
                (click)="picker_4.open()"/>
              <mat-datepicker-toggle matSuffix [for]="picker_4"> </mat-datepicker-toggle>
              <button type="button" matSuffix mat-icon-button *ngIf="asset.next_inspection_due_date" (click)="asset.next_inspection_due_date = null" matTooltip="Remove the asset inspection due date."><mat-icon>close</mat-icon></button>
              <mat-datepicker #picker_4></mat-datepicker>
              <mat-hint>Select the asset inspection due date.</mat-hint>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <app-datetime-picker
              [selectedDateTime]="lastInspectionAtDateTime"
              [pickerName]="'lastInspectionAtDateTime'"
              [max]="today"
              [label]="'Last Inspection At'"
              [hint]="'Use the calendar icon to select the asset last inspection date and time.'"
              [selectTooltip]="'Select the asset last inspection date and time.'"
              [removeTooltip]="'Clear the asset last inspection date and time.'"
              [classes]="'full-width mb-3'"
              (pickerDetailsOutput)="getOutputDateTimeDetails($event)"></app-datetime-picker>
          </div>
          <div class="col" *ngIf="assetsService.isLifecycleEndStatus(asset.status)">
            <mat-form-field class="full-width mb-3" appearance="outline" subscriptSizing="dynamic">
              <mat-label>Lifecycle End Date</mat-label>
              <input
                matInput
                (dateInput)="onLifecycleEndDateChange($event.value)"
                [matDatepicker]="picker_5"
                [max]="today"
                placeholder="Lifecycle End Date"
                [(ngModel)]="asset.lifecycle_end_at"
                name="lifecycle_end_at"
                readonly
                (click)="picker_5.open()"/>
              <mat-datepicker-toggle matSuffix [for]="picker_5"> </mat-datepicker-toggle>
              <button type="button" matSuffix mat-icon-button *ngIf="asset.lifecycle_end_at" (click)="asset.lifecycle_end_at = null" matTooltip="Remove the asset lifecycle end date."><mat-icon>close</mat-icon></button>
              <mat-datepicker #picker_5></mat-datepicker>
              <mat-hint>Select the asset lifecycle end date.</mat-hint>
            </mat-form-field>
          </div>
        </div>

        <div class="row" *ngIf="assetsService.isLifecycleEndStatus(asset.status)">
          <div class="col-12">
            <mat-form-field class="full-width mb-3" appearance="outline" subscriptSizing="dynamic">
              <mat-label>Lifecycle End Reason</mat-label>
              <textarea
                matInput
                rows="5"
                placeholder="Lifecycle End Reason"
                [(ngModel)]="asset.lifecycle_end_reason"
                name="lifecycle_end_reason"
                id="lifecycle_end_reason">
              </textarea>
              <mat-hint>Enter a lifecycle end reason for the asset.</mat-hint>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <mat-form-field class="full-width mb-3" appearance="outline" subscriptSizing="dynamic">
              <mat-label>Emergency Shutdown Procedure</mat-label>
              <textarea
                matInput
                rows="5"
                placeholder="Emergency Shutdown Procedure"
                [(ngModel)]="asset.emergency_shutdown_procedure"
                name="emergency_shutdown_procedure"
                id="emergency_shutdown_procedure">
              </textarea>
              <mat-hint>Enter the emergency shutdown procedure for the asset.</mat-hint>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-4 mb-3">
            <mat-slide-toggle [(ngModel)]="asset.is_visible" name="is_visible">
              {{ asset.is_visible ? 'Visible on Mobile app' : 'Not Visible on Mobile app' }}
            </mat-slide-toggle>
            <mat-hint class="ml-3">Set whether this asset is shown to users in the mobile app.</mat-hint>
          </div>
          <div class="col-12 col-md-4 mb-3">
            <mat-slide-toggle [(ngModel)]="asset.is_mobile" name="is_mobile">
              {{ asset.is_mobile ? 'Movable Asset' : 'Not a Movable Asset' }}
            </mat-slide-toggle>
            <mat-hint class="ml-3">Set whether this asset can move between {{ utils.getLangTerm('parent-child-sites-combined.plural', 'Sites').toLowerCase() }}.</mat-hint>
          </div>
          <div class="col-12 col-md-4 mb-3">
            <mat-slide-toggle [(ngModel)]="asset.is_safety_critical" name="is_safety_critical">
              {{ asset.is_safety_critical ? 'Safety Critical' : 'Not Safety Critical' }}
            </mat-slide-toggle>
            <mat-hint class="ml-3">Set whether this asset requires increased attention for risk and compliance.</mat-hint>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <mat-form-field class="full-width mb-3" appearance="outline" subscriptSizing="dynamic">
              <mat-label>Notes</mat-label>
              <textarea
                matInput
                rows="5"
                placeholder="Notes"
                [(ngModel)]="asset.notes"
                name="notes"
                id="notes">
              </textarea>
              <mat-hint>Enter any notes for the asset.</mat-hint>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-4 mb-3">
            <mat-slide-toggle [(ngModel)]="asset.site_manager_can_edit" name="site_manager_can_edit">
              {{ utils.getLangTerm('parent-child-sites-combined.singular', 'Site') }} Managers' edit permission {{ asset.site_manager_can_edit ? 'granted' : 'revoked' }}
            </mat-slide-toggle>
            <mat-hint class="ml-3">Grant or revoke {{ utils.getLangTerm('parent-child-sites-combined.singular', 'Site') }} Managers' permission to edit this asset in the mobile app.</mat-hint>
          </div>
          <div class="col-12 col-md-4 mb-3">
            <mat-slide-toggle disabled [(ngModel)]="asset.enable_compliance_documents" name="enable_compliance_documents">
              Compliance Documents {{ asset.enable_compliance_documents ? 'Enabled' : 'Disabled' }}
            </mat-slide-toggle>
            <mat-hint class="ml-3"><!--Enable or disable compliance documents for this asset.-->Coming soon...</mat-hint>
          </div>
          <div class="col-12 col-md-4 mb-3">
            <mat-slide-toggle disabled [(ngModel)]="asset.enable_usage_logs" name="enable_usage_logs">
              Usage Logs {{ asset.enable_usage_logs ? 'Enabled' : 'Disabled' }}
            </mat-slide-toggle>
            <mat-hint class="ml-3"><!--Enable or disable usage logs for this asset.-->Coming soon...</mat-hint>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-4 mb-3">
            <mat-slide-toggle disabled [(ngModel)]="asset.enable_depreciation_logs" name="enable_depreciation_logs">
              Depreciation Logs {{ asset.enable_depreciation_logs ? 'Enabled' : 'Disabled' }}
            </mat-slide-toggle>
            <mat-hint class="ml-3"><!--Enable or disable depreciation logs for this asset.-->Coming soon...</mat-hint>
          </div>
          <div class="col-12 col-md-4 mb-3">
            <mat-slide-toggle disabled [(ngModel)]="asset.enable_repair_history" name="enable_repair_history">
              Repair History {{ asset.enable_repair_history ? 'Enabled' : 'Disabled' }}
            </mat-slide-toggle>
            <mat-hint class="ml-3"><!--Enable or disable repair history for this asset.-->Coming soon...</mat-hint>
          </div>
          <div class="col-12 col-md-4 mb-3">
            <mat-slide-toggle disabled [(ngModel)]="asset.enable_maintenance_records" name="enable_maintenance_records">
              Maintenance Records {{ asset.enable_maintenance_records ? 'Enabled' : 'Disabled' }}
            </mat-slide-toggle>
            <mat-hint class="ml-3"><!--Enable or disable maintenance records for this asset.-->Coming soon...</mat-hint>
          </div>
        </div>

        <div class="row" *ngIf="asset.enable_maintenance_records">
          <div class="col-12 col-md-4 mb-3">
              <mat-slide-toggle disabled [(ngModel)]="asset.enable_schedules" name="enable_schedules">
                Scheduled Maintenance {{ asset.enable_schedules ? 'Enabled' : 'Disabled' }}
              </mat-slide-toggle>
              <mat-hint class="ml-3"><!--Enable or disable scheduled maintenance for this asset.-->Coming soon...</mat-hint>
          </div>
        </div>

      </div>

    </div>

  </mat-dialog-content>

  <hr class="m-0 p-0">

  <mat-dialog-actions class="p-3">

    <div class="w-100">
      <div class="alert alert-warning mx-1 mb-2" role="alert" *ngIf="!asset.asset_type_id || !f.valid">
        Please select an asset type to associate this asset with and complete the form above.
      </div>
    </div>

    <button
      mat-raised-button
      class="my-2 ml-1 mr-2"
      type="button"
      color="secondary"
      id="asset_type_selector_button"
      (click)="onSelectAssetType()"
      [matBadge]="asset.asset_type_id ? '1' : '0'"
      matTooltip="Select the asset type you want the asset to be associated with.">
      <mat-icon>layers</mat-icon>
      {{ !asset.asset_type_id ? 'Select' : 'Change' }} Asset Type *
    </button>

    <!-- Associating an asset with a site belongs to the Sites feature area, so it is hidden when the
         account's plan does not include it. An Assets-only plan (Contractor) keeps every other
         selector on this dialog: vendors are part of Assets, and contractors and users are free. -->
    <button
      *ngIf="app.planCan(AppService.FEATURES.SITES)"
      mat-raised-button
      class="my-2 ml-1 mr-2"
      type="button"
      color="secondary"
      id="site_selector_button"
      (click)="onSelectSite()"
      [matBadge]="asset.site_id ? '1' : '0'"
      matTooltip="Select, change, or remove the {{ utils.getLangTerm('parent-child-sites-combined.singular', 'Site').toLowerCase() }} associated with this record.">
      <mat-icon>location_on</mat-icon>
      {{ !asset.site_id ? 'Select' : 'Change' }} {{ utils.getLangTerm('parent-child-sites-combined.singular', 'Site') }}
    </button>

    <button
      *ngIf="asset.owner_type == 'contractor_owned'"
      mat-raised-button
      class="my-2 ml-1 mr-2"
      type="button"
      color="secondary"
      id="contractor_owner_selector_button"
      (click)="onSelectContractorOwner()"
      [matBadge]="asset.contractor_account_id ? '1' : '0'"
      matTooltip="Select the {{ utils.getLangTerm('contractors.singular', 'Contractor').toLowerCase() }} owner you want the asset to be associated with.">
      <mat-icon>engineering</mat-icon>
      {{ !asset.contractor_account_id ? 'Select' : 'Change' }} {{ utils.getLangTerm('contractors.singular', 'Contractor') }} Owner
    </button>

    <button
      mat-raised-button
      class="my-2 ml-1 mr-2"
      type="button"
      color="secondary"
      id="vendor_selector_button"
      (click)="onSelectVendor()"
      [matBadge]="asset.vendor_id ? '1' : '0'"
      matTooltip="Select the vendor you want the asset to be associated with.">
      <mat-icon>store</mat-icon>
      {{ !asset.vendor_id ? 'Select' : 'Change' }} Vendor
    </button>

    <button
      mat-raised-button
      class="my-2 ml-1 mr-2"
      type="button"
      color="secondary"
      id="contractors_selector_button"
      (click)="onSelectContractors()"
      [matBadge]="'' + (asset.contractor_ids ? asset.contractor_ids?.length : 0)"
      matTooltip="Select the {{ utils.getLangTerm('contractors.plural', 'Contractors').toLowerCase() }} you want the asset to be associated with.">
      <fa-icon [icon]="faHardHat" class="mr-1"></fa-icon>
      {{ utils.getLangTerm('contractors.plural', 'Contractors') }}
    </button>

    <button
      mat-raised-button
      class="my-2 ml-1 mr-2"
      type="button"
      color="secondary"
      id="users_selector_button"
      (click)="onSelectUsers()"
      [matBadge]="'' + (asset.user_ids ? asset.user_ids?.length : 0)"
      matTooltip="Select the users you want the asset to be associated with.">
      <mat-icon>account_circle</mat-icon>
      Users
    </button>

    <button
      mat-raised-button
      type="button"
      color="secondary"
      class="my-2 ml-1 mr-2"
      id="tags_selector_button"
      *ngIf="canViewTags"
      (click)="onSelectTags()"
      [matBadge]="'' + (asset.tag_ids ? asset.tag_ids?.length : 0)"
      matTooltip="Select the tags you want the asset to be associated with.">
      <mat-icon>local_offer</mat-icon>
      Tags
    </button>

    <div class="w-100"></div>

    <button
      mat-raised-button
      [disabled]="!f.valid || !asset.asset_type_id"
      class="my-2 ml-1 mr-2"
      type="button"
      color="primary"
      id="save_close_button"
      (click)="onSubmit(f, true)">
      <mat-icon>save</mat-icon>
      Save & Close
    </button>

    <button
      mat-raised-button
      [disabled]="!f.valid || !asset.asset_type_id || !asset.id"
      class="my-2 ml-1 mr-2"
      type="button"
      color="primary"
      id="save_continue_button"
      (click)="onSubmit(f, true,true)"
      *ngIf="canView">
      <mat-icon>save</mat-icon>
      Save & Continue
    </button>

    <app-file-browse-button
      (selectedFiles)="onSelectFiles($event)"
      (afterDialogClosedEvent)="onSubmit(f, false)"
      parentObjectType="asset"
      [parentObjectId]="asset.id"
      [filesCount]="asset?.files?.length">
    </app-file-browse-button>

  </mat-dialog-actions>

</form>

